class HeaderController {

    constructor(
        $state,
        CurrentUser
    ) {
        'ngInject'

        this.$state = $state;
        this.CurrentUser = CurrentUser;
    }

    $onInit() {
        this.showLogoutButton = this.CurrentUser.isLoggedIn();
    }

    /***
     * Log out the current user.
     */
    logoutUser() {
        this.CurrentUser.logoutUser()
            .then((successResponse) => {
                this.$state.go('app.home', {}, {reload: true})
            })
    }

    /***
     * Determine if the Admin Panel button should be displayed (only display it to admins).
     *
     * @returns {boolean}
     */
    showAdminButton() {
        return this.CurrentUser.isClientAdmin();
    }
}

export default HeaderController;


// WEBPACK FOOTER //
// ./app/common/header/header-controller.js